<section *ngFor="let threshold of list" fxLayout="row" fxLayoutAlign="start center">
  <mat-icon class="red">warning</mat-icon>
  <span class="grey-label">{{threshold}}</span>
</section>
